import experimentFlagsHelper from '@zola-helpers/client/dist/es/util/experimentFlagsHelper';

// Experiment Keys
export const CORE_HDYHAU_REGISTRY = 'core-hdyhau-registry';
export const REGISTRY_GIFT_GIVER_TILE_HEIGHT = 'registry-gift-giver-tile-height';
export const REGISTRY_GIFT_GIVER_PDP_BADGE = 'registry-gift-giver-pdp-badge';
export const SHOP_HOLIDAY_2021 = 'shop-holidays2021'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-922
export const HDYHAU_SUBWAY = 'hdyhau-subway';
export const CARDS_REGISTRY_SEARCH_RESULTS = 'cards-registry-search-results'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1291
export const INVITES_PROMO_HIDE = 'invites-promo-hide'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1629

const FALLBACK_VARIATIONS = {
  [CORE_HDYHAU_REGISTRY]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_GIFT_GIVER_TILE_HEIGHT]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_GIFT_GIVER_PDP_BADGE]: experimentFlagsHelper.createExperimentFlags(),
  [SHOP_HOLIDAY_2021]: experimentFlagsHelper.createExperimentFlags(),
  [HDYHAU_SUBWAY]: experimentFlagsHelper.createExperimentFlags(),
  [CARDS_REGISTRY_SEARCH_RESULTS]: experimentFlagsHelper.createExperimentFlags(),
  [INVITES_PROMO_HIDE]: experimentFlagsHelper.createExperimentFlags(),
};

export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);
